import { render, staticRenderFns } from "./TrackingPage.vue?vue&type=template&id=5f28f824&scoped=true"
import script from "./TrackingPage.vue?vue&type=script&lang=js"
export * from "./TrackingPage.vue?vue&type=script&lang=js"
import style0 from "./TrackingPage.vue?vue&type=style&index=0&id=5f28f824&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f28f824",
  null
  
)

export default component.exports